module.exports = __webpack_public_path__ + "static/img/tc_logo2.1f8d4883.png";